import './Form.scss'

interface FormHeaderProps {
  children?: React.ReactNode
}

export const FormHeader: React.FC<FormHeaderProps> = ({ children }) => {
  return (
    <div className="form-header-wrapper">
      <div className="form-header">{children}</div>
    </div>
  )
}
